<template>
  <h1>仅展示.html</h1>
</template>

<script>
export default {
  name: "previewReport"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/reportTools/previewReport.vue